@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.cartypes

class CarTypeDto (
    val id: Int?,
    val nameEn: String,
    val nameAr: String,
    val code: String?,
    val imageUrl: String,
    val isDefault: Boolean,
    val hasDefaultRole: Boolean,
    val isActive: Boolean,
    val zoneId: Int?,
    val description: String?,
    val currencyId: Int,
    val additionalInfo: CarTypeAdditionalInfoDto?,
    val displayOrder: Int,
)